import { combineReducers } from 'redux';

import list from './List/reducer';
import inviteByEmail from './InviteByEmail/reducer';
import createInviteLink from './CreateInviteLink/reducer';
import edit from './Edit/reducer';
import addWithForm from './AddWithForm/reducer';
import teamsModal from './TeamsModal/reducer';
import labels from './LabelsManage/reducer';
import smsCampaigns from './SmsCampaigns/reducer';
import chat from './ChatComponent/reducer';

const usersReducer = combineReducers({
  edit,
  list,
  inviteByEmail,
  createInviteLink,
  addWithForm,
  teamsModal,
  labels,
  chat,
  smsCampaigns,
});

export default usersReducer;
